import React from "react";
import chiSono from "../assets/chi_sono.webp";
import { Helmet } from "react-helmet-async";

const About: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>Chi Sono | Riama</title>
        <meta property="og:type" content="website" />
        <meta name="description" content="Appassionata del corpo in ogni sua sfaccettatura, lavoro con profondo interesse ed entusiasmo per donare alla persona una sempre maggiore autonomia nel capirsi attraverso i segnali che il corpo invia. Lo faccio attraverso tecniche olistiche che lavorano nel profondo. Chi è Riama?" />
        <meta property="og:site_name" content="Chi Sono" />
        <meta property="og:url" content="https://riamaolistica.it/" />
        <meta property="og:title" content="Chi Sono" />
        <meta property="og:description" content="Appassionata del corpo in ogni sua sfaccettatura, lavoro con profondo interesse ed entusiasmo per donare alla persona una sempre maggiore autonomia nel capirsi attraverso i segnali che il corpo invia. Lo faccio attraverso tecniche olistiche che lavorano nel profondo. Chi è Riama?" />
        <meta property="og:image:jpg" content="https://riamaolistica.it/chi_sono.webp" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Chi Sono" />
        <meta name="twitter:description" content="Appassionata del corpo in ogni sua sfaccettatura, lavoro con profondo interesse ed entusiasmo per donare alla persona una sempre maggiore autonomia nel capirsi attraverso i segnali che il corpo invia. Lo faccio attraverso tecniche olistiche che lavorano nel profondo. Chi è Riama?" />
      </Helmet>
      <section className="about bg-riama-white py-16">
        <div className="container mx-auto flex flex-col lg:flex-row items-center">
          {/* Colonna sinistra: Immagine */}
          <div className="lg:w-1/2 px-4 mb-8 lg:mb-0">
            <img
              src={chiSono}
              alt="Chi sono"
              className="rounded-lg shadow-lg mx-auto w-full max-w-md"
            />
          </div>

          {/* Colonna destra: Testo */}
          <div className="lg:w-1/2 px-4">
            <h2 className="text-4xl font-bold text-riama-blue mb-6">CHI È RIAMA</h2>
            <p className="text-lg font-medium text-riama-red mb-4">
              RIAMA è l’anagramma di MARIA, il mio nome. Cinque lettere che parlano di me e del
              percorso che ho intrapreso quando, nel 2009, ho abbracciato le discipline olistiche.
            </p>
            <p className="text-lg font-medium text-riama-red mb-6">
              Ma RIAMA esprime anche un altro pensiero: l’amore per sé stessi/e, che può essere
              ritrovato in ogni momento della propria vita.
            </p>

            <h2 className="text-4xl font-bold text-riama-blue mb-6">CHI SONO</h2>
            <p className="text-lg font-medium text-riama-orange mb-4">
              Affascinata dai segreti che il corpo umano custodisce, nel 2009 mi sono avvicinata alla
              pratica dello shiatsu che ho studiato per tre anni, fino a conseguirne il diploma di
              abilitazione.
            </p>
            <p className="text-lg font-medium text-riama-orange mb-4">
              Col tempo e la pratica, ho voluto unire alla conoscenza della Medicina Tradizionale
              Cinese quella del Massaggio Dinamico Thailandese in quanto strumento di supporto
              all’osservazione e alla comprensione dei messaggi che il corpo costantemente ci invia.
            </p>
            <p className="text-lg font-medium text-riama-orange mb-4">
              Entrambe le discipline orientali adoperano la pressione gentile, ma incisiva, di mani,
              gomiti e ginocchia, stiramenti e trazioni degli arti per ristabilire lo stato di
              rilassamento del corpo e ripristinare il libero fluire dell’energia interiore.
            </p>
            <p className="text-lg font-medium text-riama-orange mb-4">
              Trovo estremamente affascinante la profonda saggezza che ogni corpo racchiude e che,
              tramite il tocco e la mediazione di un operatore, si ha la possibilità di far riemergere
              con il giusto ascolto e con amorevole apertura e fiducia.
            </p>
            <p className="text-lg font-medium text-riama-orange mb-4">
              Quello che cerco di diffondere e che mi è molto caro, oltre che al cercare di migliorare
              la condizione di salute di chi chiede il mio supporto, è il raggiungimento di una
              maggiore consapevolezza e capacità di ascolto del proprio corpo.
            </p>
            <p className="text-lg font-medium text-riama-orange">
              Diventando così spettatori attivi, non più passivi, della propria vita.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;